import { set } from "lodash"

export default {
  
  bind(el) {
        // 获取弹窗头部元素
        const dialogHeaderEl = el.querySelector(".el-dialog__header");
        // 获取整个弹窗元素
        const dragDom = el.querySelector(".el-dialog");
        // 获取关闭按钮元素
        const closeBtn = el.querySelector(".el-dialog__headerbtn");
 
        // 设置鼠标样式为移动
        dialogHeaderEl.style.cursor = "move";
        
        // 触摸事件相关变量
        let startX, startY, startLeft, startTop;
        let isDragging = false;
        let minDragDomLeft, maxDragDomLeft, minDragDomTop, maxDragDomTop;
        let touchStartTime = 0;
        let touchStartDistance = 0;
        let touchStartX = 0;
        let touchStartY = 0;
        let lastTouchTime = 0;
        let touchCount = 0;
        
        // 触摸事件配置
        const TOUCH_THRESHOLD = 8; // 触摸移动阈值
        const TOUCH_DELAY = 100; // 触摸延迟时间
        const TOUCH_TIMEOUT = 300; // 触摸超时时间
 
        // 监听鼠标按下事件
        dialogHeaderEl.onmousedown = (e) => {
          // 检查是否点击了关闭按钮
          if (isClickOnCloseButton(e.target)) {
            return;
          }
          handleDragStart(e.clientX, e.clientY);
        };
        
        // 监听触摸开始事件
        dialogHeaderEl.addEventListener('touchstart', (e) => {
          // 检查是否触摸了关闭按钮
          if (isClickOnCloseButton(e.target)) {
            return;
          }
          
          const touch = e.touches[0];
          const currentTime = Date.now();
          
          // 触摸状态管理
          touchStartTime = currentTime;
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
          touchStartDistance = 0;
          touchCount++;
          
          // 防止触摸事件冲突
          e.stopPropagation();
          
          // 延迟处理拖拽，避免与点击事件冲突
          setTimeout(() => {
            if (touchCount === 1) { // 确保是单次触摸
              handleDragStart(touch.clientX, touch.clientY);
            }
          }, TOUCH_DELAY);
        }, { passive: false });
        
        // 监听触摸移动事件
        document.addEventListener('touchmove', (e) => {
          if (!isDragging) return;
          
          const currentTime = Date.now();
          const touch = e.touches[0];
          
          // 防止触摸事件冲突
          e.preventDefault(); // 阻止默认滚动
          e.stopPropagation();
          
          // 计算触摸移动距离
          if (touchStartDistance === 0) {
            const deltaX = touch.clientX - touchStartX;
            const deltaY = touch.clientY - touchStartY;
            touchStartDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
          }
          
          // 只有移动距离超过阈值才开始拖拽
          if (touchStartDistance > TOUCH_THRESHOLD) {
            // 更新触摸时间
            lastTouchTime = currentTime;
            
            // 处理拖拽移动
            handleDragMove(touch.clientX, touch.clientY);
          }
        }, { passive: false });
        
        // 监听触摸结束事件
        document.addEventListener('touchend', (e) => {
          const currentTime = Date.now();
          const touchDuration = currentTime - touchStartTime;
          
          // 触摸状态重置
          touchCount = Math.max(0, touchCount - 1);
          
          // 如果触摸时间很短且移动距离很小，可能是点击事件
          if (touchDuration < TOUCH_TIMEOUT && touchStartDistance < TOUCH_THRESHOLD) {
            // 不处理拖拽，让点击事件正常触发
            handleDragEnd();
            return;
          }
          
          // 正常拖拽结束
          handleDragEnd();
        }, { passive: false });
        
        // 监听触摸取消事件
        document.addEventListener('touchcancel', (e) => {
          // 触摸被取消，重置状态
          touchCount = 0;
          handleDragEnd();
        }, { passive: false });
        
        // 检查是否点击了关闭按钮
        function isClickOnCloseButton(target) {
          // 检查目标元素或其父元素是否为关闭按钮
          let currentTarget = target;
          while (currentTarget && currentTarget !== dialogHeaderEl) {
            if (currentTarget.classList && 
                (currentTarget.classList.contains('el-dialog__headerbtn') ||
                 currentTarget.classList.contains('el-dialog__close') ||
                 currentTarget.classList.contains('el-icon-close'))) {
              return true;
            }
            currentTarget = currentTarget.parentElement;
          }
          return false;
        }
        
        // 触摸事件处理函数
        function handleDragStart(clientX, clientY) {
          // 防止重复启动拖拽
          if (isDragging) return;
          
          // 计算触摸点相对弹窗头部的偏移量
          const disX = clientX - dialogHeaderEl.offsetLeft;
          const disY = clientY - dialogHeaderEl.offsetTop;
 
          // 获取可视区域的宽高
          const screenWidth = document.body.clientWidth;
          const screenHeight = document.body.clientHeight;
 
          // 获取弹窗的宽高
          const dragDomWidth = dragDom.offsetWidth;
          const dragDomHeight = dragDom.offsetHeight;
 
          // 计算可移动范围的边界值
          minDragDomLeft = dragDom.offsetLeft;
          maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
 
          minDragDomTop = dragDom.offsetTop;
          maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight;
 
          // 用于存储弹窗的位置信息
          let styL, styT;
 
          // 处理弹窗位置的百分比值转换为像素值
          if (window.getComputedStyle(dragDom).left.includes("%")) {
            // 如果位置使用百分比，转换为像素值
            styL =
              +document.body.clientWidth *
                (+window.getComputedStyle(dragDom).left.replace(/%/g, "") / 100);
            styT =
              +document.body.clientHeight *
                (+window.getComputedStyle(dragDom).top.replace(/%/g, "") / 100);
          } else {
            // 如果位置使用像素值，直接获取数值
            styL = +window.getComputedStyle(dragDom).left.replace(/px/g, "");
            styT = +window.getComputedStyle(dragDom).top.replace(/px/g, "");
          }
          
          // 存储起始位置
          startX = clientX;
          startY = clientY;
          startLeft = styL;
          startTop = styT;
          isDragging = true;
          
          // 移除触摸拖拽样式类添加，保持对话框外观不变
          // dialogHeaderEl.classList.add('touch-dragging');
          // dragDom.classList.add('touch-dragging');
          
          // 监听鼠标移动事件
          document.onmousemove = function (e) {
            handleDragMove(e.clientX, e.clientY);
          };
 
          // 监听鼠标松开事件
          document.onmouseup = function () {
            handleDragEnd();
          };
          
          // 添加触摸拖拽状态指示
        }
        
        // 拖动移动处理函数
        function handleDragMove(clientX, clientY) {
          if (!isDragging) return;
          
          // 计算新的位置
          let left = clientX - (startX - startLeft);
          let top = clientY - (startY - startTop);
 
          // 限制左右移动范围
          if (-left > minDragDomLeft) {
            left = -minDragDomLeft;
          } else if (left > maxDragDomLeft) {
            left = maxDragDomLeft;
          }
 
          // 限制上下移动范围
          if (-top > minDragDomTop) {
            top = -minDragDomTop;
          } else if (top > maxDragDomTop) {
            top = maxDragDomTop;
          }
 
          // 更新弹窗位置
          dragDom.style.cssText += `;left:${left}px;top:${top}px;`;
        }
        
        // 拖动结束处理函数
        function handleDragEnd() {
          if (!isDragging) return;
          
          isDragging = false;
          
          // 移除触摸拖拽样式类，保持对话框外观不变
          // dialogHeaderEl.classList.remove('touch-dragging');
          // dragDom.classList.remove('touch-dragging');
          
          // 清除鼠标移动和松开事件的监听
          document.onmousemove = null;
          document.onmouseup = null;
          
          // 重置触摸状态
          touchStartDistance = 0;
          touchCount = 0;
          
          // 添加触摸拖拽状态指示
        }
        
        // 清理函数
        el._cleanupDragDialog = () => {
          // 移除触摸事件监听器
          document.removeEventListener('touchmove', handleTouchMove);
          document.removeEventListener('touchend', handleTouchEnd);
          document.removeEventListener('touchcancel', handleTouchCancel);
          
          // 重置状态
          isDragging = false;
          touchCount = 0;
          
          // 移除样式类
          if (dialogHeaderEl) {
            dialogHeaderEl.classList.remove('touch-dragging');
          }
          if (dragDom) {
            dragDom.classList.remove('touch-dragging');
          }
        };
      },
      
      // 组件销毁时清理
      unbind(el) {
        if (el._cleanupDragDialog) {
          el._cleanupDragDialog();
        }
      }
}